// Core
import { useState, useCallback, useMemo } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

// Assets
import { apiService } from 'services/ApiService';

// Components
import WheelsEditContent from './components/BasePriceContent';

import { PLAN_TYPES } from '../../../constants/plan';
import BasePriceContent from './components/BasePriceContent';

const basePriceSchema = z.object({
  code: z.string().min(1),
  price: z.coerce.number(),
});

const BasePriceEdit = () => {
  const history = useHistory();
  const { id } = useParams();

  const [errorCard, setErrorCard] = useState();

  const form = useForm({
    resolver: zodResolver(basePriceSchema),
    defaultValues: {
      code: '',
      price: 0,
    },
  });

  const { reset, handleSubmit } = form;

  const { isLoading, isError } = useQuery({
    queryKey: ['base-prices', id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      if (id === 'new') {
        reset({
          code: '',
          price: 0,
        });
        return true;
      }
      const response = await apiService.getBasePrice({ id });
      reset(response.data);
      return true;
    },
  });

  const mutation = useMutation({
    mutationFn: async (data) => {
      if (id === 'new') {
        return apiService.createBasePrice(data);
      } else {
        return apiService.updateBasePrice({ id, ...data });
      }
    },
    onSuccess: (res) => {
      if (res.data === false || !(res.statusCode >= 200 && res.statusCode < 300)) {
        setErrorCard(res.message);
        return;
      }
      history.push('/base-prices');
    },
    onError: () => {
      setErrorCard('Something went wrong.');
    },
  });

  const onSubmit = (values) => {
    mutation.mutate(values);
  };

  const onError = (errors) => {
    console.log('Validation errors:', errors);

    const messages = Object.values(errors)
        .map((err) => err?.message)
        .filter(Boolean)
        .join('. ');

    setErrorCard(messages);
  };

  const handleDelete = useCallback(async () => {
    await apiService.deleteBasePrice({id});
    reset({
      code: '',
      price: 0,
    });
    history.push('/base-prices');
  }, [history, id, reset]);

  return (isError ?
    <div>Not Found</div> : isLoading ?
    <div>Loading...</div> :
        <BasePriceContent handleDelete={handleDelete} isNew={id === 'new'} form={form} onSubmit={handleSubmit(onSubmit, onError)} isSubmitting={mutation.isLoading} errorCard={errorCard} />
  );
};

export default BasePriceEdit;